import { STATUS } from "@/lib/format";

export const StatusBadge = ({ statut, testId }) => {
  const s = STATUS[statut] || STATUS.sans_carte;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};
